var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C18.4949 4 14 8.49492 14 14C14 19.5051 18.4949 24 24 24C29.5051 24 34 19.5051 34 14C34 8.49492 29.5051 4 24 4ZM24 7C27.8838 7 31 10.1162 31 14C31 17.8838 27.8838 21 24 21C20.1162 21 17 17.8838 17 14C17 10.1162 20.1162 7 24 7ZM11.9785 28C9.7987 28 8 29.7987 8 31.9785V33.5C8 37.1042 10.2793 39.8922 13.3066 41.5625C16.334 43.2328 20.1681 44 24 44C27.8319 44 31.666 43.2328 34.6934 41.5625C37.2746 40.1383 39.2173 37.8626 39.7617 35H40.002V31.9785C40.002 29.7987 38.2013 28 36.0215 28H11.9785ZM11.9785 31H36.0215C36.5797 31 37.002 31.4203 37.002 31.9785V32H37V33.5C37 35.8958 35.6543 37.6078 33.2441 38.9375C30.834 40.2672 27.4181 41 24 41C20.5819 41 17.166 40.2672 14.7559 38.9375C12.3457 37.6078 11 35.8958 11 33.5V31.9785C11 31.4203 11.4203 31 11.9785 31Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.440a43a1d54e0acf99103582cf74dbb7.svg";
export { ForwardRef as ReactComponent };